import React from 'react';
import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";

const Home = () => {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  );
};

export default Home;